<template>
    <v-container
        fluid
        class="sidebar-content general-sidebar_inside map-sidebar"
        ref="sidebarMap"
    >
        <v-list class="listreset d-flex">
            <v-list-item
                v-for="(item, id) in getItems()"
                :key="id"
                class="justify-center"
            >
                <v-tooltip 
                    content-class="bottom" 
                    bottom
                >
                    <template v-slot:activator="{ on, attrs }">
                        <a
                            v-bind="attrs"
                            v-on="on"
                            href="#"
                            :class="{ 'active': item.active }"
                            @click.prevent="setActive(item)"
                        >
                            <span class="icon-holder">
                                <svg
                                    width="30"
                                    height="30"
                                >
                                    <image
                                        v-if="item.active"
                                        :xlink:href="item.icon"
                                        :src="item.icon"
                                        width="30"
                                        height="30"
                                    />
                                    <image
                                        v-else
                                        :xlink:href="item.inactiveIcon"
                                        :src="item.inactiveIcon"
                                        width="30"
                                        height="30"
                                    />
                                </svg>
                            </span>
                        </a>
                    </template>
                    <span>
                        {{ item.text }}
                    </span>
                </v-tooltip>
            </v-list-item>
        </v-list>
        <div class="pt-4 pb-2">
            <div class="search-block">
                <input
                    v-show="isSearchExist()"
                    type="search"
                    ref="search"
                    v-model="inputSearch"
                    :placeholder="searchPlaceholder()"
                >
                <button
                    v-if="inputSearch == ''"
                    class="btn-search"
                >
                    <em class="icon icon-search search-btn"/>
                </button>
                <button
                    v-else class="btn-search"
                    @click="resetSearch()"
                >
                    <em class="icon icon-close reset-btn"/>
                </button>
            </div>
        </div>

        <div
            class="result-search-block pb-12"
            v-show="!!data.info"
        >
            {{ data.info }}
        </div>
        <div
            class="point pb-8"
            v-for="(point, id) in data.points"
            :key="`point-${id}`"
        >
            <div class="scrolable-box-heading">
                <h3>
                    {{point.text}}
                </h3>
            </div>
            <v-list class="props-list props-list_wide">
                <v-list-item
                    v-for="(item, id) in point.categories"
                    :key="`category-${id}`"
                    class="pl-4"
                    :class="{ 'pb-2': id < point.categories.length - 1 }"
                >
                    <a
                        href="#"
                        :class="{ 'active': item.active }"
                        @click.prevent="toggleState(item)"
                    >
                        <span class="icon-holder">
                            <svg
                                width="20"
                                height="20"
                            >
                                <image
                                    v-if="item.active"
                                    :xlink:href="item.icon"
                                    :src="item.icon"
                                    width="20"
                                    height="20"
                                />
                                <image
                                    v-else
                                    :xlink:href="item.inactiveIcon"
                                    :src="item.inactiveIcon"
                                    width="20"
                                    height="20"
                                />
                            </svg>
                        </span>
                        {{ item.text }}
                    </a>
                </v-list-item>
            </v-list>
        </div>
    </v-container>
</template>

<script>
    import { EventBus } from '@/event-bus';

    export default {
        name: 'MapSidebar',
        props: [
            'data',
            'handler'
        ],
        data() {
            return {
                inputSearch: ""
            };
        },
        mounted() {
            if (typeof this.data.search === 'function')
                this.data.search(this.$refs.search);

            this.data.gui.itinerary.filter(el => !!el.active).forEach(el => {
                if (typeof this.data.travelMode === 'function')
                    this.data.travelMode(el.id);
            });
            this.handler();
        },
        methods: {
            getItems() {
                return this.data.gui.itinerary.filter(el => el.id !== 'destination');
            },
            isSearchExist() {
                return this.data.gui.itinerary.filter(el => el.id === 'destination').length;
            },
            searchPlaceholder() {
                const item = this.data.gui.itinerary.filter(el => el.id === 'destination');
                return item.length && item[0].text ? item[0].text : '';
            },
            setActive(item) {
                if (!item.active) {
                    this.data.gui.itinerary.filter(el => el.active).forEach(el => el.active = false);
                    this.$set(item, 'active', true);
                    EventBus.$emit('map_SetActive', item);
                }
            },
            toggleState(item) {
                this.$set(item, 'active', !item.active);
                this.data.refreshHotspots(item, item.active);
            },
            resetSearch() {
                this.inputSearch = '';
                this.$refs.search.value = '';
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/sidebar/MapSidebar.vue